import { createSlice } from "@reduxjs/toolkit";


const nameSlice = createSlice({
    name: 'Product',
    initialState: {
        productNewList:[
            {
                id: 2,
                type: 1,//1:单列,2:双列
                header: ['', 'NVIDIA  B200'],
                parameter: [
                    ['GPUs', '8x NVIDIA B200 SXM'],
                    ['FP4 Tensor Core*', '144 PFLOPS'],
                    ['FP8/FP6 Tensor Core*', '72 PFLOPS'],
                    ['INT8 Tensor Core*', '72 POPS'],
                    ['FP16/BF16 Tensor Core*', '36 PFLOPS'],
                    ['TF32 Tensor Core*', '18 PFLOPS'],
                    ['FP32', '640 TFLOPS'],
                    ['FP64', '320 TFLOPS'],
                    ['FP64 Tensor Core', '320 TFLOPS'],
                    ['显存', 'Up to 1.5TB'],
                    ['NVLink', '第五代'],
                    ['NVSwitch', '第四代'],
                    ['NVSwitch GPU 到 GPU 的带宽', '1.8TB/s'],
                    ['总聚合带宽', '14.4TB/s'],
                ],
            },
            {
                id: 2,
                type: 2,//1:单列,2:双列
                header: ['', 'NVIDIA  H100', 'NVIDIA  H200'],
                parameter: [
                    ['GPUs', 'HGX H100 8-GPU', 'HGX H200 8-GPU'],
                    ['外形', '8x NVIDIA H100 SXM', '8x NVIDIA H200 SXM'],
                    ['FP8 Tensor Core', '32 PFLOPS', '32 PFLOPS'],
                    ['INT8 Tensor Core', '32 PFLOPS', '32 POPS'],
                    ['FP16/BFLOAT16 Tensor Core', '16 PFLOPS', '16 PFLOPS'],
                    ['TF32 Tensor Core', '8 PFLOPS', '8 PFLOPS'],
                    ['FP32', '540 TFLOPS', '540 TFLOPS'],
                    ['FP64', '270 TFLOPS', '270 TFLOPS'],
                    ['FP64 Tensor Core', '540 TFLOPS', '540 TFLOPS'],
                    ['显存', '640GB HBM3', '1.1TB HBM3e'],
                    ['GPU 带宽', '27GB/s', '38GB/s'],
                    ['NVLink', '第四代', '第四代'],
                    ['NVSwitch', '第三代', '第三代'],
                    ['NVSwitch GPU 到 GPU 的带宽', '900GB/', '900GB/'],
                    ['总聚合带宽', '7.2TB/s', '7.2TB/s'],
                ],
            },
            {
                id: 3,
                type: 1,//1:单列,2:双列
                header: ['', 'AMD MI300X'],
                parameter: [
                    ['外形规格', '8 Instinct MI300X OAM GPUs'],
                    ['光刻技术', '5nm FinFET'],
                    ['Active interposer dies (AIDs)', '6nm FinFET'],
                    ['GPU计算单元', '2432'],
                    ['矩阵核', '9728'],
                    ['流处理器', '155648'],
                    ['Peak engine clock', '2100 MHz'],
                    ['存储容量', '1.5 TB HBM3'],
                    ['内存带宽', '5.3 TB/s max. peak theoretical'],
                    ['内存接口', '8192 bits per GPU'],
                    ['AMD Infinity Cache™（最新级别）', '256 MB per GPU'],
                    ['显存频率', 'Up to 5.2 GT/s'],
                    ['Scale-up Infinity Fabric™ Links', '7x 128 GB/s per GPU'],
                    ['聚合带宽', '896 GB/s'],
                    ['扩展网络带宽', '8 PCIe® Gen 5 x16 (128 GB/s) per GPU'],
                    ['RAS特性', '全芯片内存'],
                    ['最大 TBP', '750W per GPU'],

                ],
            },
        ],
        productAiList:[
            {
                id: 4,
                type: 1,//1:单列,2:双列
                bannerHeader:['NVIDIA HGX系列', 'AI加速的技术革新平台'], 
                bannerLine:[
                    '·专为 AI 和 HPC 而打造的高效加速计算平台',
                    '·卓越的端到端加速计算平台',
                    '·深度学习推理：适用于新一代大型语言模型的实时推理',
                    '·深度学习训练：训练性能进一步提升',
                    '·借助NVIDIA网络来加速HGX',
                    '·将HGX与NVIDIA网络相连'
                   ],  
                BannerImg:require("@/assets/product/ai1.png").default,
                captionBig:'X8000G6I',
                captionSmall:'最先进的AI和HPC计算工作负载平台',
                captionLine:[
                '·模块化架构为客户提供最佳性能平台',
                '·通过 NVIDIA® NVLink™ 桥接器和 NVIDIA® NVSwitch™ 实现最佳 GPU 通信，适用于 NVIDIA® HGX™ H100/H200/B200 8-GPU 系统',
                '·DDR5 和 PCIe Gen5 平台设计',
                '·为 GPU 直接远程直接内存访问提供最大带宽',
                '·通过分离 12V 和 54V 电源提高电源效率和可靠性',
                '·采用模块化设计，具有出色的可维护性和可组装性'
               ],
                productImg:[require("@/assets/product/X8000G6I.jpg").default],
                parameter: [
                    ['产品规格', ['8U 机架','宽 x 高 x 深: 448x 352x 850 mm']],
                    ['GPU', ['选项(1)8 * Nvidia H100/H200,SXM5 GPU','选项(2)8 * Nvidia B100 (Umbriel),SXM6 GPU']],
                    ['主板', 'Intel EGS CPU最高385W'],
                    ['PCIe扩展', ['选项(1)1x FHHLDW','选项(2)2x FHHLSW','选项(3)1 × OCP 3.0 SFF + 1 × FHHLSW']],
                    ['PCIe 插槽​（from Switch）', '8 x低规格卡（PCIeG5x16）'],
                    ['存储（from Switch)', '8个U.2 NVMe SSD托架'],
                    ['存储 (from MB)', ['4 x U.2 NVMe SSD托架','2 x M.2 SATA SSD或NVMe SSD']],
                    ['系统管理', '1x RJ45用于BMC（AST2600）远程管理'],
                    ['冷却', ['选项(1)风冷','选项(2)']],
                    ['电源', ['3300W 54V电源模块，支持3+3冗余','2400W 12V电源模块，支持1+1冗余']],
                    ['风扇', ['10 * 8086风扇，用于GPU散热','6 * 6056风扇为CPU散热']],
                ],
            },
            {
                id: 5,
                type: 1,//1:单列,2:双列
                bannerHeader:['NVIDIA HGX系列', 'AI加速的技术革新平台'], 
                bannerLine:[
                    '·专为 AI 和 HPC 而打造的高效加速计算平台',
                    '·卓越的端到端加速计算平台',
                    '·深度学习推理：适用于新一代大型语言模型的实时推理',
                    '·深度学习训练：训练性能进一步提升',
                    '·借助NVIDIA网络来加速HGX',
                    '·将HGX与NVIDIA网络相连'
                   ],  
                BannerImg:require("@/assets/product/ai1.png").default,
                captionBig:'X8000G6A',
                captionSmall:'NVIDIA HGX架构：重度AI工作负载的最佳选择',
                captionLine:[
                '·搭载第五代英特尔®至强®可扩展处理器',
                '·PCIe Gen5.0准备就绪',
                '·强大的性能，支持NVIDIA HGX H100 8- gpu，并连接最新的NVSwitch设计',
                '·加强IT基础设施管理',
               ],
                productImg:[require("@/assets/product/X8000G6A.png").default],
                parameter: [
                    ['主板', 'Z13PN-D32'],
                    ['中央处理器 / 系统总线', ['2 x Socket（LGA 4677）','支持第四代与第五代 Intel® Xeon® Scalable 系列中央处理器（最高至 350W）','UPI 16 GT/s']],
                    ['核心逻辑', 'Intel® C741'],
                    ['总插槽数', '总插槽数：32（每个CPU 8通道；每个CPU 16 个存储条）'],
                    ['扩展容量', '扩展容量：最大 4 + 8TB（DDR5 + Crow Pass）'],
                    ['存储器类型', '存储器类型：DDR5 4400 RDIMM / 3DS RDIMM（每个通道 2 DIMM）'],
                    ['存储器大小', ['64GB、32GB、16GB（RDIMM）','256GB、128GB（3DS RDIMM）']],
                    ['总 PCI / PCIe 插槽', ['ESC N8-E11（H100 SKU）：12','ESC N8-E11V（H200 SKU）：10+1']],
                    ['支持插槽类型', ['ESC N8-E11（H100 SKU）*：',
                    '- 8 x PCIe（Gen5 x16 link，LP/HL，PCIe switch）',
                    '- 2 x PCIe（Gen5 x16 link，FH/HL，CPU1/2）**',
                    '- 2 x PCIe（Gen5 x8 link，FH/HL，CPU1/2） ESC N8-E11V（H200 SKU）*：',
                    '- 8 x PCIe（Gen5 x16 link，LP/HL，PCIe switch）',
                    '- 2 x PCIe（Gen5 x16 link，FH/HL，CPU1/2）**',
                    '- 1 x PCIe（Gen4 x8 link，FH/HL，CPU2 DMI）供 RAID卡',
                    '*BF3 在使用收发器时的操作温度为 30℃.',
                    '**支援 PCIe x16 link 供 DPU.'
                    ]],
                    ['M.2', ['ESC N8-E11（H100 SKU）：',
                    '2 x M.2 插槽（Gen5 x4 link，CPU1，最高至 2280）',
                    '2 x M.2 插槽（Gen3 x2 link，PCH，最高至 2280） ESC N8-E11V（H200 SKU）：',
                    '2 x M.2 插槽（Gen3 x2 link，PCH，最高至 2280）'
                    ]],
                    ['MicroSD 存储卡插槽', '1 x 供 BMC 记录'],
                    ['存储设备插槽', ['8 x 前面板可热插拔 2.5 英寸存储设备插槽',
                        '- PCIe direct： 8 x NVMe',
                        '2 x 后面板可热插拔 2.5 英寸存储设备插槽',
                        '- CPU2 direct： 2 x NVMe/SATA(PCH)'
                     ]],
                     ['管理网络', ['2 x 双界面 Intel® X710-AT2 10GbE 网络控制器','1 x 管理网络界面']],
                     ['尺寸（高 x 宽 x 长）', '885 mm x 447 mm x 306.65 mm（7U）'],
                     ['电源', '4+2 or 3+3 3000W 80 PLUS Titanium 电源（PSU）'],
                     ['环境条件', ['操作温度：10℃ ~ 35℃  未操作温度：-40℃ ~ 70℃','未操作湿度：20% ~ 90%（无结露）']],
                ],
            },
            {
                id: 6,
                type: 1,//1:单列,2:双列
                bannerHeader:['NVIDIA DGX系列 | AI核心，尽在掌握','适用于所有 AI 基础架构的通用系统'], 
                bannerLine:[
                    '·专为企业级AI设计的平台',
                    '·经过验证业的AI标准',
                    '·体验 DGX 平台的优势（先进的AI开发平台、融入了 NVIDIA AI 专业技术和服务、性能卓越、成本可预测）',
                    '·DGX 助力 AI 走向各行各业',
                    '·云端部署是启用 DGX 的最快方式',
                    '·DGX 平台随附强大的 AI 软件套件'
                   ],  
                BannerImg:require("@/assets/product/ai2.png").default,
                captionBig:'DGX H100',
                captionSmall:[],
                captionLine:[
                '利用 NVIDIA DGX™ H100 拓展创新和优化的前沿领域。',
                'DGX H100 是 NVIDIA 传奇的 DGX 系统的最新迭代，也是 NVIDIA DGX SuperPOD™ 的基础，它是由 NVIDIA H100 Tensor Core GPU 的突破创新加速的 AI 动力之源。',
               ],
                productImg:[require("@/assets/product/DGX-H100.png").default,require("@/assets/product/DGX-H100-2.png").default,],
                parameter: [
                    ['GPU', '8 个 NVIDIA H100 Tensor Core GPU'],
                    ['GPU 显存','共 640GB'],
                    ['性能','32 petaFLOPS FP8'],
                    ['NVIDIA® NVSwitch™','4x'],
                    ['系统功耗','最高 10.2kW'],
                    ['CPU','双路 x86'],
                    ['网络',['4 个 OSFP 端口，提供 8 个单端口 NVIDIA ConnectX-7 网卡',
                    '>最大400Gb/s 无线带宽/以太网',
                    '2 个双端口 NVIDIA BlueField-3 DPU VPI',
                    '1 个 400Gb/s 的 无线带宽/ 以太网网卡',
                    '1 个 200Gb/s 的 Infini']],
                    ['管理网络',['RJ45 接口 10Gb/s 板载网卡',
                    '50Gb/s 的以太网可选网卡',
                    'RJ45 接口主机基板管理控制器（BMC）',
                    '2 个 NVIDIA BlueField-3']],
                    ['存储',['操作系统 ： 2 块 1.9TB NVMe M.2硬盘','内部存储 ： 8 块 3.84TB NVMe U.2硬盘']],
                    ['系统软件',['DGX H100 系统预安装 DGX 操作系统，该操作系统基于 Ubuntu Linux，包含DGX 软件堆栈（所有必要软件包和驱动均针对 DGX 优化）。','客户可以选择单独安装 Ubuntu Linux 或 Red Hat Enterprise以及必要的 DGX 软件堆栈。']],
                    ['运行温度范围','5 至 30°C'],
                ],
            }, 
            {
                id: 7,
                type: 1,//1:单列,2:双列
                bannerHeader:['NVIDIA DGX系列 | AI核心，尽在掌握','适用于所有 AI 基础架构的通用系统'], 
                bannerLine:[
                    '·专为企业级AI设计的平台',
                    '·经过验证业的AI标准',
                    '·体验 DGX 平台的优势（先进的AI开发平台、融入了 NVIDIA AI 专业技术和服务、性能卓越、成本可预测）',
                    '·DGX 助力 AI 走向各行各业',
                    '·云端部署是启用 DGX 的最快方式',
                    '·DGX 平台随附强大的 AI 软件套件'
                   ],  
                BannerImg:require("@/assets/product/ai2.png").default,
                captionBig:'DGX H200',
                captionSmall:[],
                captionLine:[
                '全球使用者首选的企业人工智能产品',
                '以 NVIDIA DGX™ H200 拓展商业创新与最佳化的新疆界。',
                'DGX H200 隶属于 DGX 平台，为 NVIDIA DGX SuperPOD™ 和 DGX BasePOD™ 提供强大的人工智能基础，并由 NVIDIA H200 Tensor 核心 GPU 带来绝佳的加速效能。'
               ],
                productImg:[require("@/assets/product/DGX-H200.png").default,require("@/assets/product/DGX-H200-2.png").default,],
                parameter: [
                    ['GPU', '8x NVIDIA H200 Tensor Core GPUs, 每颗141GB GPU内存'],
                    ['GPU 显存','1,128GB'],
                    ['性能','32 petaFLOPS FP8'],
                    ['NVIDIA® NVSwitch™','4x'],
                    ['系统电源','10.2kW max*'],
                    ['CPU',['2 x Intel®Xeon®白金8480C处理器','112核心，2.00 GHz（基础）','3.80 GHz (Max Boost)']],
                    ['网络',['4个OSFP端口，服务于8个单端口NVIDIA ConnectX-7 VPI',
                    '>最大400Gb/s 无线带宽/以太网',
                    '2个双端口QSFP112 NVIDIA ConnectX-7 VPI',
                    '>最大400Gb/s 无线带宽/以太网',]],
                    ['管理网络',['10Gb/s板载网卡，RJ45100Gb/s以太网网卡',
                    '带有RJ45的主机基底板管理控制器（BMC）',]],
                    ['存储','OS: 2x 1.92TB NVMe M'],
                    ['内部存储','8x 3.84TB NVMe U.2'],
                    ['系统软件',['NVIDIA AI企业-优化的AI软件',
                    'NVIDIA基础命令-编排，调度和集群管理',
                    'DGX OS / Ubuntu / Red Hat Enterprise Linux / Rocky -操作系统']],
                    ['系统重量','287.6lbs (130.45kgs)'],
                    ['包装重量','376lbs (170.45kgs)'],
                    ['系统尺寸',['高: 14.0in (356mm)',
                    '宽: 19.0in (482.2mm)',
                    '长: 35.3in (897.1mm)']],
                    ['运行中温度范围','5–30°C (41–86°F)'],
                ],
            },
            {
                id:8,
                type: 1,//1:单列,2:双列
                bannerHeader:['NVIDIA DGX系列 | AI核心，尽在掌握','适用于所有 AI 基础架构的通用系统'], 
                bannerLine:[
                    '·专为企业级AI设计的平台',
                    '·经过验证业的AI标准',
                    '·体验 DGX 平台的优势（先进的AI开发平台、融入了 NVIDIA AI 专业技术和服务、性能卓越、成本可预测）',
                    '·DGX 助力 AI 走向各行各业',
                    '·云端部署是启用 DGX 的最快方式',
                    '·DGX 平台随附强大的 AI 软件套件'
                   ], 
                BannerImg:require("@/assets/product/ai2.png").default,
                captionBig:'DGX B200',
                captionSmall:[],
                captionLine:[
                'NVIDIA DGX™ B200是一个统一的人工智能平台，用于在人工智能旅程的任何阶段为任何规模的企业开发部署管道。DGX B200配备了八个与第五代NVIDIA® NVLink®互连的NVIDIA Blackwell GPU，提供领先的性能，提供前几代的3倍训练性能和15倍的推理性能。利用NVIDIA Blackwell GPU架构，DGX B200可以处理多样化的工作负载——包括大型语言模型、推荐系统和聊天机器人——使其成为希望加速人工智能转型的企业的理想选择。',],
                productImg:[require("@/assets/product/DGX-B200.png").default],
                parameter: [
                    ['图形处理器', '8x NVIDIA Blackwell GPU'],
                    ['GPU内存', '总GPU内存为1,440GB'],
                    ['性能', '72 petaFLOPS训练和144 petaFLOPS推理'],
                    ['耗电量', '~14.3千瓦最大值'],
                    ['中央处理器', ['2个英特尔®至强®白金8570处理器','共112个核心，2.1 GHz（基础），','4 GHz（最大升压）']],
                    ['系统内存', '高达4TB'],
                    ['网络', ['4x OSFP端口服务 8x单端口NVIDIA ConnectX-7 VPI',
                    '>高达400Gb/s 无线带宽/以太网',
                    '2x 双端口QSFP112 NVIDIA BlueField-3 DPU',
                    '>高达400Gb/s 无线带宽/以太网']],
                    ['管理网络', ['管理网络 带有RJ45的10Gb/s板载网卡',
                    '100Gb/s双端口以太网网卡',
                    '带有RJ45的主机底板管理控制器（BMC）']],
                    ['储存', ['操作系统：2x 1.9TB NVMe M.2','内部存储：8x 3.84TB NVMe U.2']],
                    ['系统软件', ['软件 NVIDIA AI Enterprise：优化的人工智能软件',
                     'NVIDIA基本命令™：编排、调度和集群管理', 
                     'DGX OS / Ubuntu：操作系统']],
                    ['机架单元（RU）', '10 RU'],
                    ['系统尺寸', ['高度：17.5英寸（444毫米）',
                     '宽度：19.0英寸（482.2毫米）',
                     '长度：35.3英寸（897.1毫米）'
                    ]],
                    ['工作温度', '5–30°C (41–86°F)'],
                ],
            }, 
            {
                id:9,
                type: 1,//1:单列,2:双列
                bannerHeader:['华为鲲鹏处理器'], 
                bannerLine:[
                    '华为自主研发的一款基于ARM架构的企业级处理器产品',
                    '具备多种优势，在多个领域广泛应用'
                ], 
                BannerImg:require("@/assets/product/ai4.png").default,
                captionBig:'Atlas 800I A2推理服务器',
                captionSmall:[],
                captionLine:[
                'Atlas 800I A2 推理服务器采用8模组高效推理方式，提供强劲 AI 推理能力，在算力、内存带宽和互联能力方面具有优势，可广泛应用于生成式大模型推理，例如智能客服、文案生成、知识沉淀等内容生成类场景，支持NPU互联，提升大模型推理效率。',],
                productImg:[require("@/assets/product/Atlas-800I-A2.png").default],
                parameter: [
                    ['形态', '4U AI服务器'],
                    ['CPU', '4 * 鲲鹏920'],
                    ['内存', ['32个DDR4内存插槽，最高3200 MT/s','单根内存条容量支持16/32/64 GB']],
                    ['本地存储', ['8 * 2.5 SATA+2 * 2.5 NVMe','4 * 2.5 SATA+6 * 2.5 NVMe']],
                    ['RAID支持', '支持 RAID 0/1/10/5/50/6/60'],
                    ['内部网络', '可选NPU全互联机型，整机互联带宽392GB/s'],
                    ['外部网络', '8 * 200GE QSFP接口直出，RoCE协议'],
                    ['PCIe接口', '最多支持3个PCIe 4.0扩展插槽'],
                    ['电源', '4个热插拔2.6kW电源模块，支持2+2冗余'],
                    ['供电', ['200 ~ 240V AC','240V DC']],
                    ['散热方式', '风冷'],
                    ['风扇', '支持8个热拔插风扇模组，支持N+1冗余'],
                    ['工作环境温度', '5℃～35℃（41℉～95℉）'],
                    ['结构尺寸', '175mm（高） * 447mm（宽）* 790mm（深）'],
                ],
            },
            {
                id:10,
                type: 1,//1:单列,2:双列
                bannerHeader:['华为鲲鹏处理器'], 
                bannerLine:[
                    '华为自主研发的一款基于ARM架构的企业级处理器产品',
                    '具备多种优势，在多个领域广泛应用'
                ],  
                BannerImg:require("@/assets/product/ai4.png").default,
                captionBig:'Atlas 800T A2训练服务器',
                captionSmall:[],
                captionLine:[
                'Atlas 800T A2训练服务器具有更高算力密度、极致能效比与高速网络带宽等特点。该服务器广泛应用于深度学习模型开发和训练，适用于智慧城市、智慧金融、教育科研、运营商等需要大算力的行业领域。',],
                productImg:[require("@/assets/product/Atlas-800T-A2.png").default],
                parameter: [
                    ['形态', '4U AI服务器'],
                    ['CPU', '4 * 鲲鹏920'],
                    ['内存', ['32个DDR4内存插槽，最高3200 MT/s','单根内存条容量支持16/32/64 GB']],
                    ['本地存储', ['7 * 2.5 SATA+3 * 2.5 NVMe','8 * 2.5 SATA+2 * 2.5 NVMe','4 * 2.5 SATA+6 * 2.5 ']],
                    ['RAID支持', '支持 RAID 0/1/10/5/50/6/60'],
                    ['网络', '8 * 200GE QSFP接口直出，RoCE协议'],
                    ['PCIe接口', '最多支持3个PCIe 4.0扩展插槽'],
                    ['电源', '4个热插拔2.6kW电源模块，支持2+2冗余'],
                    ['供电', ['200 ~ 240V AC','240V DC']],
                    ['散热方式', '风冷'],
                    ['风扇', '支持8个热拔插风扇模组，支持N+1冗余'],
                    ['工作环境温度', '5℃～35℃（41℉～95℉）'],
                    ['结构尺寸', '175mm（高） * 447mm（宽）* 790mm（深）'],
                ],
            },
            {
                id:11,
                type: 2,//1:文字样式,2:图片样式
                bannerHeader:['NVL 72 | AI驱动模块化高效计算'], 
                bannerLine:[
                    '·通过模块化服务器架构，将高性能计算无缝融入各类数据中心',
                    '·模块化灵活的计算平台'
                ],  
                BannerImg:require("@/assets/product/ai3.png").default,
                captionBig:'',
                captionSmall:[],
                captionLine:[],
                productImg:[],
                parameter: [],
                pageImg:[require("@/assets/product/ai72-1-1.jpg").default,require("@/assets/product/ai72-1-2.jpg").default,]
            },  
            {
                id:12,
                type: 2,//1:文字样式,2:图片样式
                bannerHeader:['NVL 72 | AI驱动模块化高效计算'], 
                bannerLine:[
                    '·通过模块化服务器架构，将高性能计算无缝融入各类数据中心',
                    '·模块化灵活的计算平台'
                ],  
                BannerImg:require("@/assets/product/ai3.png").default,
                pageImg:[require("@/assets/product/ai72-2.jpg").default,]
            },               
        ],

        },
    reducers: {
        changeState(state, { payload }) {
            console.log('jinlai le', payload)
            state.state = payload
        }
    }
})
export const getters = (state) => {
    console.log('++++++++++++', state)
    return state.Product
}
export const { changeState } = nameSlice.actions
export default nameSlice.reducer
